// The collection page: filters, sort, type pills and load more swap the shelf in place through
// Shopify's Section Rendering API, and the URL follows, so every state can be shared or refreshed.
// Without script every control is still a link or a form.
(function () {
  'use strict';

  const root = document.querySelector('[data-collection]');
  if (!root) return;

  const PHONE = '(max-width: 640px)';
  const PAGE_PARAM = 'page';
  const TYPE_PARAM = 'filter.p.product_type';
  const sectionId = root.getAttribute('data-section-id');
  const baseUrl = root.getAttribute('data-url') || location.pathname;
  const q = (selector, from = root) => from.querySelector(selector);

  // The URL for the choices on screen: the type pill from the address, everything else from the form.
  function stateUrl(overrides = {}) {
    const current = new URLSearchParams(location.search);
    const next = new URLSearchParams();
    if (current.has(TYPE_PARAM)) current.getAll(TYPE_PARAM).forEach((v) => next.append(TYPE_PARAM, v));
    const form = q('[data-filters]');
    if (form) {
      for (const [key, value] of new FormData(form).entries()) {
        if (value === '' || key === 'price-band' || key === TYPE_PARAM) continue;
        next.append(key, String(value));
      }
    }
    const sort = q('[data-sort]');
    if (sort && sort.value) next.set('sort_by', sort.value);
    Object.entries(overrides).forEach(([key, value]) => {
      next.delete(key);
      if (value !== null && value !== undefined && value !== '') next.set(key, value);
    });
    next.delete(PAGE_PARAM);
    const query = next.toString();
    return `${baseUrl}${query ? `?${query}` : ''}`;
  }

  async function load(url, { append = false } = {}) {
    root.setAttribute('aria-busy', 'true');
    try {
      const fetchUrl = new URL(url, location.href);
      fetchUrl.searchParams.set('section_id', sectionId);
      const res = await fetch(fetchUrl.toString(), { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(`${res.status}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-shelf]');
      if (!fresh) throw new Error('no shelf');
      if (append) {
        const grid = q('[data-grid]');
        const first = grid.children.length;
        fresh.querySelectorAll('[data-grid] > *').forEach((node) => grid.appendChild(node));
        const more = q('[data-more]');
        const freshMore = fresh.querySelector('[data-more]');
        if (more && freshMore) more.replaceWith(freshMore); else if (more) more.remove();
        const next = grid.querySelectorAll('.card__title a')[first];
        if (next) next.focus({ preventScroll: true });
      } else {
        const wasOpen = q('[data-filters]') && q('[data-filters]').hasAttribute('data-open');
        q('[data-shelf]').replaceWith(fresh);
        const pills = doc.querySelector('[data-pills]');
        const ours = q('[data-pills]');
        if (pills && ours) ours.replaceWith(pills);
        if (wasOpen) openSheet();
      }
      history.replaceState(null, '', url);
    } catch (err) {
      location.href = url; // the plain page still has every state
    } finally {
      root.removeAttribute('aria-busy');
    }
  }

  // ----- events -----
  root.addEventListener('change', (e) => {
    const form = q('[data-filters]');
    if (e.target.matches('[data-sort]')) { load(stateUrl()); return; }
    if (!form || !form.contains(e.target)) return;
    if (e.target.name === 'price-band') {
      const min = form.querySelector('[data-price-min]');
      const max = form.querySelector('[data-price-max]');
      if (min) min.value = e.target.getAttribute('data-gte') || '';
      if (max) max.value = e.target.getAttribute('data-lte') || '';
    }
    load(stateUrl());
  });

  root.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-type]');
    if (pill) { e.preventDefault(); load(stateUrl({ [TYPE_PARAM]: pill.getAttribute('data-type') })); return; }
    const remove = e.target.closest('[data-remove], [data-clear]');
    if (remove && remove.getAttribute('href')) { e.preventDefault(); load(remove.getAttribute('href')); return; }
    const more = e.target.closest('[data-more-btn]');
    if (more) { e.preventDefault(); load(more.getAttribute('href'), { append: true }); return; }
    if (e.target.closest('[data-filters-open]')) { openSheet(); return; }
    if (e.target.closest('[data-filters-close]')) { closeSheet(); return; }
    if (e.target.closest('[data-filters-done]')) { e.preventDefault(); closeSheet(); }
  });

  // One dropdown open at a time on a wide screen; a click elsewhere closes it.
  document.addEventListener('click', (e) => {
    if (window.matchMedia(PHONE).matches) return;
    root.querySelectorAll('details.filter[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const form = q('[data-filters]');
    if (form && form.hasAttribute('data-open')) { closeSheet(); return; }
    const open = root.querySelector('details.filter[open]');
    if (open) { open.removeAttribute('open'); open.querySelector('summary').focus(); }
  });

  // On a phone the filters are one sheet with every group open.
  function openSheet() {
    const form = q('[data-filters]');
    if (!form) return;
    form.setAttribute('data-open', '');
    form.querySelectorAll('details').forEach((d) => d.setAttribute('open', ''));
    document.body.style.overflow = 'hidden';
    const close = form.querySelector('[data-filters-close]');
    if (close) close.focus();
  }
  function closeSheet() {
    const form = q('[data-filters]');
    if (!form) return;
    form.removeAttribute('data-open');
    form.querySelectorAll('details').forEach((d) => d.removeAttribute('open'));
    document.body.style.overflow = '';
    const opener = q('[data-filters-open]');
    if (opener) opener.focus();
  }
})();